/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const SideProductPickerFragment = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  SideProductPicker: gql`
    fragment SideProductPickerQuery on sideProductPicker_Entry {
      typeHandle
      productPicker {
        ... on productPickerBlock_Entry {
          styles
          ctaLabel
          ctaType
          productPickerHeading
          productCategory {
            ... on productPickerCategories_Category {
              productPickerCtaLabel
              productPickerTable {
                courseType
                ctaOverride
                noFollow
                noReferrer
                modal
                productLink
                productName
                state
              }
            }
          }
        }
      }
      sideContent
      mobileBannerOptions {
        ... on mobileBannerOptionsBlock_Entry {
          displayMobileBanner
          styles
          bannerText
          ctaLabel
          ctaType
        }
      }
    }
  `,
};
